import React from "react";
import AssignAnOrder from "../AssignAnOrder";

export default function OrderHeader({ singleOrder }) {
  return (
    <>
      <div className="mb-4 d-flex  flex-wrap justify-content-between">
        <h3 className="text-primary">Order #{singleOrder.id}</h3>
        {singleOrder.status === "assigned" && (
          <div>
            <span className="badge badge-pill badge-outline-success p-2 m-1">
              Assigned
            </span>
          </div>
        )}
        {singleOrder.status === "unassigned" && (
          <AssignAnOrder id={singleOrder.id} />
        )}
        {singleOrder.status === "delivered" && (
          <div>
            <span className="badge badge-pill badge-outline-success p-2 m-1">
              Delivered
            </span>
          </div>
        )}
      </div>
      <div>
        <h5 className="text-capitalize">
          {singleOrder.third_party_order === true && (
            <span className="badge badge-pill badge-outline-success p-2 mb-2">
              Food App Order
            </span>
          )}
          {singleOrder.second_party_order === true && (
            <span className="badge badge-pill badge-outline-success p-2 mb-2">
              DashBoard Side Order
            </span>
          )}
        </h5>
      </div>
    </>
  );
}
